// stroke
const Bookmark = ({
  width = '24',
  height = '24',
  className = '',
  title = '',
  stroke = '1.5',
  role = ''
}): React.ReactNode => {
  const hidden = title && title.length > 0 ? false : true;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      stroke="#000000"
      aria-hidden={`${hidden}`}
      role={role ? role : hidden ? 'graphics-document' : 'img'}
    >
      {!hidden && <title>{title}</title>}
      <path
        d="M17.2667 20.9723L12 17.2856L6.73333 20.9723C6.6397 21.0378 6.52988 21.0764 6.41584 21.0839C6.3018 21.0914 6.18789 21.0674 6.08651 21.0147C5.98512 20.9619 5.90015 20.8824 5.84082 20.7847C5.78149 20.687 5.75007 20.5749 5.75 20.4606V4.16064C5.75 3.82912 5.8817 3.51118 6.11612 3.27676C6.35054 3.04234 6.66848 2.91064 7 2.91064H17C17.3315 2.91064 17.6495 3.04234 17.8839 3.27676C18.1183 3.51118 18.25 3.82912 18.25 4.16064V20.4606C18.2499 20.5749 18.2185 20.687 18.1592 20.7847C18.0999 20.8824 18.0149 20.9619 17.9135 21.0147C17.8121 21.0674 17.6982 21.0914 17.5842 21.0839C17.4701 21.0764 17.3603 21.0378 17.2667 20.9723Z"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
      <path
        d="M9.5 2.91162V19.0358"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
      <path
        d="M14.5 2.91162V19.0358"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
    </svg>
  );
};

export default Bookmark;
